import { render, staticRenderFns } from "./Header_info.vue?vue&type=template&id=c6f2ad2e"
import script from "./Header_info.vue?vue&type=script&lang=js"
export * from "./Header_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports